/* eslint-disable */
import { Add, HighlightOff } from '@mui/icons-material';
import SelectPicker from 'rsuite/SelectPicker';
import { addCommas, classes } from '../../Helpers';
import styles from './POTotalContainer.module.scss';

function POTotalContainer(props) {
	const {
		calculatedData,
		packagingCharges,
		taxPercentage = 5,
		deliveryCharges,
		handleChange,
		showCharges = false,
		disableCharges = true,
		showAdditionalCharge = false,
		allowAddAdditional = true,
		allowRemoveAdditional = true,
		additionalCharges = [],
		handleAdditionalCharges = () => { },
		addAdditonalCharges = () => { },
		handleRemoveAdditionalCharge = () => { },
		definedAdditionalCharges = [],
		itemLevelChargesTotal = 0,
		hideTax = false,
	} = props;
	const hasDefinedCharges = Array.isArray(definedAdditionalCharges) &&
		definedAdditionalCharges.length > 0;

	// When `hideTax` is true (intra-entity transfer, same GSTIN on both stores)
	// the tax shouldn't be displayed or included in the grand total — also
	// applies to Delivery / Packaging / Additional charges tax displays.
	const totalTaxAmount = Number(calculatedData?.totalTax) || 0;
	const displayedTotalAmount = hideTax
		? (Number(calculatedData?.totalAmount) || 0) - totalTaxAmount
		: calculatedData?.totalAmount;
	// Effective tax % shown on charge tiles — 0 when intra-entity transfer.
	const effectiveTaxPercentage = hideTax ? 0 : taxPercentage;

	return (
		<div className={styles.root}>
			<div className={classes(styles['total-container'])}>
				{!!calculatedData?.totalDiscount && (
					<div className={classes(styles.tile)}>
						<p className={styles.title}>
							Total Discount
						</p>
						<p className={styles.discount}>
							₹(-
							{addCommas(calculatedData?.totalDiscount)}
							)
						</p>
					</div>
				)}
				<div className={classes(styles.tile)}>
					<p className={styles.title}>
						Sub Total (
						{calculatedData?.totalQuantity}
						{' '}
						Item(s))
					</p>
					<p className={styles.value}>
						₹
						{addCommas(calculatedData?.subTotal)}
					</p>
				</div>
				{!!calculatedData?.freightVendorCost && (
					<div className={classes(styles.tile)}>
						<p className={styles.title}>Freight Vendor Charges</p>
						<p className={styles.value}>₹{addCommas(calculatedData?.freightVendorCost)}</p>
					</div>
				)}
				{showCharges && (
					<>
						<div className={classes(styles.tile)}>
							<p className={styles.title}>Delivery Charges: </p>
							<div className={styles?.container}>
								<div className={styles?.tax}>
									Tax:
									{' '}
									{effectiveTaxPercentage}
									%
								</div>
								<div>
									₹
									{' '}
									<input
										// name=''
										disabled={disableCharges}
										type='text'
										min={0}
										className={styles.charges}
										value={deliveryCharges}
										onChange={(e) => {
											const value = e?.target?.value;
											const isPositiveDecimal =
												/^(?:\d+(\.\d*)?|\.\d+)?$/.test(value);
											if (value === '' || isPositiveDecimal) {
												handleChange(
													'SET_DELIVERY_CHARGES',
													e.target?.value
												);
											}
										}}
									/>
								</div>
								<div className={styles?.appliedTax}>
									Tax amount
									{': '}
									{((deliveryCharges * effectiveTaxPercentage) / 100)?.toFixed(2)}
								</div>
							</div>
						</div>
						<div className={classes(styles.tile)}>
							<p className={styles.title}>Packaging Charges: </p>
							<div className={styles?.container}>
								<div className={styles?.tax}>
									Tax:
									{' '}
									{effectiveTaxPercentage}
									%
								</div>
								<div>
									₹
									{' '}
									<input
										// name=''
										disabled={disableCharges}
										type='text'
										min={0}
										className={styles.charges}
										value={packagingCharges}
										onChange={(e) => {
											const value = e?.target?.value;
											const isPositiveDecimal =
												/^(?:\d+(\.\d*)?|\.\d+)?$/.test(value);
											if (value === '' || isPositiveDecimal) {
												handleChange(
													'SET_PACKAGING_CHARGES',
													e.target?.value
												);
											}
										}}
									/>
								</div>
								<div className={styles?.appliedTax}>
									Tax amount
									{': '}
									{((packagingCharges * effectiveTaxPercentage) / 100)?.toFixed(2)}
								</div>
							</div>
						</div>
					</>
				)}
				{showAdditionalCharge && (
					<div className={styles.additional_charge_container}>
						{additionalCharges?.map((ele, idx) => {
							return (
								<div className={styles.additional_charge}>
									<div className={styles.text_input}>
										{hasDefinedCharges ? (
											<SelectPicker
												style={{
													width: '14rem',
												}}
												data={definedAdditionalCharges?.map((c) => ({
													label: c?.chargeName,
													value: c?.id,
												}))}
												value={ele?.chargeId ?? null}
												onChange={(value) => {
													handleAdditionalCharges(idx, {
														target: {
															name: 'chargeId',
															value,
														},
													});
												}}
												placeholder='Select charge'
												searchable={false}
												cleanable={false}
											/>
										) : (
											<input
												name='type'
												className={styles.charges}
												value={ele?.type}
												onChange={(e) => {
													handleAdditionalCharges(idx, e);
												}}
											/>
										)}
										:
									</div>
									<div className={styles.tax_price}>
										Tax %
										<input
											name='taxPercentage'
											type='text'
											min={0}
											className={styles.tax_percentage}
											value={hideTax ? 0 : ele?.taxPercentage}
											disabled={hideTax}
											onChange={(e) => {
												const value = e?.target?.value;
												const isPositiveDecimal =
													/^(?:\d+(\.\d*)?|\.\d+)?$/.test(
														value
													);
												if (value === '' || isPositiveDecimal) {
													handleAdditionalCharges(idx, e);
												}
											}}
										/>
										₹
										<div className={styles.charge_price}>
											<input
												name='price'
												disabled={disableCharges}
												type='text'
												min={0}
												className={styles.charges}
												value={ele?.price}
												onChange={(e) => {
													const value = e?.target?.value;
													const isPositiveDecimal =
														/^(?:\d+(\.\d*)?|\.\d+)?$/.test(
															value
														);
													if (isPositiveDecimal) {
														handleAdditionalCharges(
															idx,
															e
														);
													}
												}}
											/>
											<div className={styles?.tax_amount}>
												Tax amount
												{': '}
												{((ele?.price *
													(hideTax ? 0 : ele?.taxPercentage)) /
													100)?.toFixed(2)}
											</div>
											{idx > 0 && allowRemoveAdditional && (
												<div
													className={styles.remove_charge}
													onClick={() => {
														handleRemoveAdditionalCharge(idx);
													}}
												>
													<HighlightOff
														className={styles.icon}
													/>
												</div>
											)}
										</div>
									</div>
								</div>
							);
						})}
						{allowAddAdditional && (
							<div className={styles.add_additional}>
								<button onClick={addAdditonalCharges} type='button' className={styles.btn}>
									<Add />
									Add Additional Charge
								</button>
							</div>
						)}
					</div>
				)}
				{!!itemLevelChargesTotal && (
					<div className={classes(styles.tile)}>
						<p className={styles.title}>Item Additional Charges</p>
						<p className={styles.value}>
							₹
							{addCommas(itemLevelChargesTotal)}
						</p>
					</div>
				)}
				{!hideTax && 'taxValues' in calculatedData && (
					<div className={classes(styles.tile)}>
						<p className={styles.title}>Total Tax: </p>
						<div className={styles['milti-gst']}>
							{Object.keys(calculatedData?.taxValues ?? {})?.map(
								(eleKey) => {
									const element =
										calculatedData?.taxValues?.[eleKey];
									return (
										<>
											<p className={styles.value}>
												{eleKey}
												:
												{' '}
												₹
												{addCommas(element)}
											</p>
										</>
									);
								}
							)}
							<p className={styles.value}>
								Total:
								{' '}
								₹
								{addCommas(calculatedData?.totalTax)}
							</p>
						</div>
					</div>
				)}
				<div className={classes(styles.tile, styles?.finalAmount)}>
					<p className={styles.title}>
						Total Amount
					</p>
					<p className={styles.value}>
						₹
						{addCommas(displayedTotalAmount)}
					</p>
				</div>
			</div>
		</div>
	);
}

export default POTotalContainer;
